// material-ui
import {Img} from 'react-image'; 
import {Grid,Typography} from '@mui/material';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Mantis" width="100" />
     *
     */
    <>
      
      <Grid 
        container 
        direction="column" 
        sx={{
          width: '100%',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.8,
            transform: 'scale(1.02)'
          },
          transition: 'all 0.2s ease-in-out'
        }} 
        justifyContent="flex-start" 
        alignItems="center"
        onClick={handleLogoClick}
      >
        <Grid item sx={{ width: '100%' }}>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Img src="/gnr-logo.jpeg" width="200px" height="120px"/>
            </Grid>
            <Grid item sx={{ px: 2, textAlign: 'center', mt: 0 }}>
              <Typography
                variant="subtitle1"
                color="text.primary"
                sx={{ fontWeight: 600, letterSpacing: 0.4, lineHeight: 1.2, mt: 0 }}
              >
                GLAMOURR&amp;RADIANCE
                <br />
                LIFESTYLE PRIVATE LIMITED
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item>
          <Img src="/gnr-barcode.jpeg" width="200px" height="120px"/>
        </Grid>
         <Grid item>
          <Typography variant="subtitle2" color="secondary" component="span" sx={{paddingTop:2}}>
            Scan to open GNRonline Web App
          </Typography>
         </Grid> */}
        
      </Grid>
    </>
  );
};

export default Logo;
